import type { ColumnConfigEntry } from "./columnConfig";

/** The AP invoices list's column-config table id. */
export const AP_INVOICES_TABLE_ID = "ap-invoices";

/**
 * The AP invoices list's built-in columns, in default order, without headers:
 * the frontend translates them and the seed writes English ones. Each id is
 * also its base `apiField`.
 */
export const AP_INVOICE_BASE_COLUMNS = [
  { id: "createdAt", apiField: "createdAt", sortable: true, format: "date" },
  { id: "receivedAt", apiField: "receivedAt", sortable: true, format: "date" },
  {
    id: "invoiceNumber",
    apiField: "invoiceNumber",
    sortable: true,
    format: "string",
  },
  {
    id: "invoiceDate",
    apiField: "invoiceDate",
    sortable: true,
    format: "date",
  },
  { id: "dueDate", apiField: "dueDate", sortable: true, format: "date" },
  {
    id: "totalAmount",
    apiField: "totalAmount",
    sortable: true,
    format: "currency",
  },
  {
    id: "supplierId",
    apiField: "supplierId",
    sortable: true,
    format: "string",
  },
  {
    id: "referenceIds",
    apiField: "referenceIds",
    sortable: true,
    format: "string",
  },
  { id: "status", apiField: "status", sortable: true, format: "string" },
  {
    id: "paymentStatus",
    apiField: "paymentStatus",
    sortable: true,
    format: "string",
  },
  {
    id: "noteCount",
    apiField: "noteCount",
    sortable: false,
    format: "integer",
  },
] as const satisfies readonly Omit<ColumnConfigEntry, "header">[];

export type APInvoiceBaseColumnId =
  (typeof AP_INVOICE_BASE_COLUMNS)[number]["id"];
